import  { useState, useRef } from 'react';
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import HomeContactUsModal from "../../pages/home/homeHeader/homeContactUsModal/homeContactUs";
import { useNavigate } from 'react-router-dom';

const BasicHeader = () => {
    const [open, setOpen] = useState(false);
    const [hamburgerIsClicked, setHamburgerIsClicked] = useState(false)
    const history = useNavigate();
    const hamburger = useRef(0);

    const gotoHomePage = (e) => {
        history("/")
      }
      const openSupportModal = () => {
        setOpen(true);
      }

      const _modalClose = () => {
        setOpen(false);
      }
    
      const hamburgerClicked = () => {
        setHamburgerIsClicked(!hamburgerIsClicked)
      }

    return (
        <>
        <div className="nav_bg_home home-specific-header">
            <div className="container w1200 nav_bg_home_section">
                <div className="nav_bg_left">

                    <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
                        <div><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></div>
                    </li>

                </div>
                <div className="nav_bg_right">
                    <ul className="navbar_home">
                        <li className="special_hover cp" onClick={openSupportModal}><>Contact Us</></li>
                    </ul>
                </div>
            </div>
        </div>

      {/*-------> Nav Header Mobile <------*/ }
    <div className='nav_bg_home_responsive'>
        <div className="nav_bg_home_responsive-wrapper">
            <div className="home-top-nav">
                <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
                    <div><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></div>
                </li>
                <div className={hamburgerIsClicked ? "hamburgerIsClicked" : "hamburgerIsNotClicked"} ref={hamburger}>
                    <ul className="navbar_home-responsive">
                        <li className="special_hover cp" onClick={openSupportModal}><>Contact Us</></li>
                    </ul>
                </div>
                <div className="icon" onClick={hamburgerClicked}>
                    <i className="fa fa-bars"></i>
                </div>
            </div>
        </div>
    </div>
    <HomeContactUsModal
        modalOpen={open}
        modalClose={_modalClose}
      />
    </>
     
  )
}

export default BasicHeader